/**
 * Call Chakra's Toast anywhere with these helpers.
 *
 * @remarks
 * toast type not found.
 */

interface IToastProps {
  toast: any;
  title: string;
  description: string;
}
type TToastHelper = (props: IToastProps) => void;

export const SuccessToastHandler: TToastHelper = ({
  toast,
  title,
  description,
}: IToastProps) => {
  toast({
    title,
    description,
    variant: "left-accent",
    position: "bottom-right",
    status: "success",
    isClosable: true,
  });
};

export const ErrorToastHandler: TToastHelper = ({
  toast,
  title,
  description,
}: IToastProps) => {
  toast({
    title,
    description,
    variant: "left-accent",
    position: "bottom-right",
    status: "error",
    isClosable: true,
  });
};
